import React from 'react';
import {WIDTH} from '../../Card';
import SliderArrow from './SliderArrow';
import resizeThrottler from './resizeThrottler';

const SLIDE_WIDTH = WIDTH + 25;

class Slider extends React.Component {
  constructor(props){
    super(props);
    this.state = {firstVisible: 0, capacity:0, animate: ""};
    this.selectedIdx = props.selectedSlideIdx + 1;
    this.sliderDiv = null;
    this.resizeHandler = resizeThrottler(this.updateSliderState);
  }

  componentDidMount(){
    this.sliderDiv = document.getElementById('a-slider');
    this.setState({capacity: this.calculateCapacity()}, () => this.slideToIdx(this.selectedIdx));
    window.addEventListener("resize", this.resizeHandler, false);
  }

  componentWillUnmount(){
    window.removeEventListener("resize", this.resizeHandler)
  }

  calculateCapacity = () => {
    const sliderWidthPX = this.sliderDiv !== null ? this.sliderDiv.offsetWidth : 0
    return Math.ceil( sliderWidthPX / SLIDE_WIDTH ) - 1
  }

  updateSliderState = () => {
    const newCapacity = this.calculateCapacity()
    if (newCapacity !== this.state.capacity) {this.setState({capacity: newCapacity})}
  }

  slide = (offset) => { this.setState({firstVisible: this.state.firstVisible + offset}) }

  slideLeft = () => { this.canSlideLeft() && this.slide(-1) }

  slideRight = () => { this.canSlideRight() && this.slide(1) }

  slideToIdx = idx => { this.slide(Math.max(0, idx - this.state.capacity)) }

  canSlideLeft = () => this.state.firstVisible > 0

  canSlideRight = () => this.state.firstVisible + this.state.capacity < this.props.slideCount

  leftOffset = () => -1 * this.state.firstVisible * SLIDE_WIDTH

  render(){
    return(
      <div className="slider-container relative t-mh3 t-mh2-m">
        { this.canSlideLeft()  && <SliderArrow url="/images/webreader/arrow-left.svg"  onClick={this.slideLeft}  className="a-left" />}
        { this.canSlideRight() && <SliderArrow url="/images/webreader/arrow-right.svg" onClick={this.slideRight} className="a-right"/>}
        <div className="a-slider-wrapper nowrap overflow-hidden t-pb2">
          <div id="a-slider" className={`relative tc ${this.state.animate}`} style={{transform: `translateX(${this.leftOffset()}px)`}}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

}

export default Slider
